import { gsap } from 'gsap';

const navContainer = document.querySelector('.header-content-wrapper');
if (navContainer) {
	const headerNav = navContainer.querySelector('#header-navigation');
	const menuItems = gsap.utils.toArray(headerNav.children);
	const line = navContainer.querySelector('.nav-line');
	const currentPageItem = navContainer.querySelector('.parent-menu-item.active');
	let isLoading = false;
	let activeItem = menuItems[0];

	// Animate to menu item
	const setPoint = options => {
		options = options || {};
		const el = options.el || currentPageItem || activeItem;
		const elWidth = el.offsetWidth;
		const lineWidth = line.offsetWidth;
		if(!isLoading){
			gsap.to(line, {
				x: el.offsetLeft + elWidth / 2 - lineWidth / 2,
				duration: options.xDuration || 0,
				ease: 'expo.out',
				overwrite: true,
			});
			gsap.to(line, {
				scale: options.opacity ? 1 : 0,
				opacity: options.opacity || 0,
				duration: options.oDuration || 0,
				ease: 'back.out',
			});
			activeItem = el;
		}
	};

	// Cursor entering items
	menuItems.forEach(el => {
		el.onmouseover = () => {
			const visible = parseFloat(getComputedStyle(line).opacity);
			setPoint({
				el,
				opacity: 1,
				xDuration: visible ? 0.5 : 0,
				oDuration: 0.4,
			});
		}
	});

	// Cursor leaving nav
	navContainer.onmouseleave = () => {
		setPoint({
			opacity: currentPageItem ? 1 : 0,
			xDuration: 0.5,
			oDuration: 0.4,
		});
	};

	// Starting point
	setPoint({
		opacity: currentPageItem ? 1 : 0
	});

	// Prevent animations when leaving page
	window.addEventListener('beforeunload', () => {
		isLoading = true;
	});
}
